/* eslint-disable tss-unused-classes/unused-classes */

import { Theme } from '@mui/material';
import { colors } from '../../../../../styles/styleVariables';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  validationLoader: {
    position: 'absolute',
    left: 'calc(50% - 20px)',
    top: '50%',
  },
  searchDialogContainer: {
    minWidth: '1250px',
    minHeight: '560px',
  },

  dialogContainer: {
    minWidth: '430px',
    minHeight: '360px',
    height: 'auto',
    maxHeight: 'none',
  },
  dialogContent: {
    paddingTop: 0,
    overflow: 'hidden',
    'overflow-y': 'scroll',
    paddingBottom: '24px',
  },
  dialogActionsRoot: {
    backgroundColor: '#f8f8f8',
    boxShadow: '0px -1px 4px rgba(0, 0, 0, 0.10)',
    padding: '10px 24px',
  },
  root: {
    padding: '0px 0px',
  },
  action: {
    display: 'flex',
    flexDirection: 'row',
  },
  actionBtn: {
    fontSize: 12,
    padding: 0,
    minWidth: 30,
  },
  actionNoBtn: {
    color: '#888888',
  },
  actionYesBtn: {
    color: `${theme.palette.components.button.secondary.backgroundColor} !important`,
  },

  datePickerInput: {
    height: '55px',
    width: 'auto',
  },

  label: {
    fontSize: '14px !important',
    color: 'rgba(0, 0, 0, 0.37)',
    '&.Mui-focused': {
      color: 'rgba(0, 0, 0, 0.37)',
    },
    '&[class*="MuiInputLabel-outlined"]': {
      marginTop: '1px',
    },
  },

  searchButton: {
    height: 'auto',
    width: 'auto',
    alignItems:'center',
    backgroundColor: 'transparent',
    '&:disabled': { backgroundColor: 'transparent !important;' },
    '& .MuiSvgIcon-root': {
      color: `${colors.white}`,
      backgroundColor: `${colors.amnLightGrey}`,
      borderRadius: '6px 6px 6px 6px',
      width: '1.3em',
      height: '1.3em',
    },
    '& .MuiTypography-root': {
      color: `${colors.darkText}`,
      paddingLeft: '15px',
    },
    '&:hover': { background: 'none' },
    '&:hover .MuiSvgIcon-root ': {
      backgroundColor: `${colors.amnLightBlue}`,
    },
    '&:hover .MuiTypography-root': {
      color: `${colors.amnLightBlue}`,
    },
  },

  fillterCollapse: {
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: '3px',
  },
  collapse: {
    paddingTop: '4px',
  },
}));
